.infoText {
  color: var(--body-text-arrows-400);
}

.form-subtitle {
  margin-top: calc(var(--spacer) * 4);
  margin-bottom: calc(var(--spacer));
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
  width: fit-content;
}

#detonation-profile-form-field {
  max-width: 800px;
}
